/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  NFTToolsFeature,
  NFTToolsFeatureInterface,
} from "../NFTToolsFeature";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "zeroExAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EIP712_DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FEATURE_NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FEATURE_VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC721Token",
            name: "token",
            type: "address",
          },
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
        ],
        internalType: "struct INFTToolsFeature.TransferERC721AsseetsParam[]",
        name: "erc721s",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "contract IERC1155Token",
            name: "token",
            type: "address",
          },
          {
            internalType: "address",
            name: "to",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct INFTToolsFeature.TransferERC1155AsseetsParam[]",
        name: "erc1155s",
        type: "tuple[]",
      },
    ],
    name: "batchTransferNFTAssetsFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "migrate",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class NFTToolsFeature__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    zeroExAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NFTToolsFeature> {
    return super.deploy(
      zeroExAddress,
      overrides || {}
    ) as Promise<NFTToolsFeature>;
  }
  getDeployTransaction(
    zeroExAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(zeroExAddress, overrides || {});
  }
  attach(address: string): NFTToolsFeature {
    return super.attach(address) as NFTToolsFeature;
  }
  connect(signer: Signer): NFTToolsFeature__factory {
    return super.connect(signer) as NFTToolsFeature__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NFTToolsFeatureInterface {
    return new utils.Interface(_abi) as NFTToolsFeatureInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NFTToolsFeature {
    return new Contract(address, _abi, signerOrProvider) as NFTToolsFeature;
  }
}
